import React from "react";
import PropTypes from "prop-types";
//Limitless imports
import DataTable from "./DataTable";
import CustomThemeSection from "../custom-theme-section/CustomThemeSection";
import { INITIAL_OPTIONS } from "../../hooks/table-state/TableStateHook";
const ResponsiveDataTable = ({
  height = 0,
  ...rest
}) => {
  let isPaginated = false;
  if (typeof rest.options.pagination === "boolean") {
    isPaginated = rest.options.pagination;
  } else {
    const rowsPerPage = rest.options.rowsPerPage || INITIAL_OPTIONS.rowsPerPage;
    if (rest.data.length > rowsPerPage) {
      isPaginated = true;
    }
  }
  rest.options.pagination = isPaginated;
  const tableHeight = isPaginated ? height + 40 : height;
  return /*#__PURE__*/React.createElement(CustomThemeSection, {
    componentOverrides: {
      MUIDataTable: {
        styleOverrides: {
          responsiveBase: {
            maxHeight: `calc(100vh - ${tableHeight}px) !important`
          },
          paper: {
            display: "grid"
          }
        }
      }
    }
  }, /*#__PURE__*/React.createElement(DataTable, rest));
};
export default ResponsiveDataTable;
ResponsiveDataTable.propTypes = {
  height: PropTypes.number
};